/**
 * Copyright (c) 2019 Burst Apps Team
 */

/**
 * @internal
 * Size of Code Pages in bytes
 * @module contracts
 */
export const CodePageSize = 256;
